export default __webpack_public_path__ + "static/media/diamond-cut-4@3x.b563d3eb.jpg";